import { render, staticRenderFns } from "./CabinetOld.vue?vue&type=template&id=c8510906&"
import script from "./CabinetOld.vue?vue&type=script&lang=js&"
export * from "./CabinetOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports